export default {
  dataInicial: {
    value: '',
    required: true,
    state: null
  },
  tipo: {
    value: '',
    required: true,
    state: null
  },
  descricao: {
    value: '',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros_atendimento/TiposFinalizacao/components/add/TiposFinalizacao-form.js